import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        mutations
    },
    state: {
      // 存储token
      Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : ''
    },
    mutations: {
      // 修改token，并将token存入localStorage
      changeLogin (state, user) {
        state.Authorization = user.Authorization;
        localStorage.setItem('Authorization','bearer'+ user.Authorization);
      }
    },
    actions
})


// WEBPACK FOOTER //
// ./src/store/store.js